import React from 'react';
import { Routes, Route } from 'react-router-dom';

import { ThemeProvider } from 'styled-components';

import LoginPage from 'pages/login/LoginPage';
import MetaLeadsOverview from 'pages/meta/MetaLeadsOverview';
import ToolsPage from 'pages/toolsPage/ToolsPage';
import InvoicingPage from 'pages/invoicing/InvoicingPage';
import ReportingPage from 'pages/reportingPage/ReportingPage';
import AdsPage from 'pages/adsPage/AdsPage';
import { ThemeModeProvider, useThemeMode } from 'stores/ThemeContext';

const lightColors = {
  background: '#ffffff',
  background100: '#f8f8fa',
  background200: '#f1f2f3',
  background300: '#e3e5e8',
  mainTextColor: '#737b8c',
  boldTextColor: '#000000',
  white: '#ffffff',
  accentColor: '#ffcc00'
};

const darkColors = {
  background: '#1a1a2e',
  background100: '#16213e',
  background200: '#0f3460',
  background300: '#2a2a4a',
  mainTextColor: '#a0a0b8',
  boldTextColor: '#e0e0e0',
  white: '#1a1a2e',
  accentColor: '#ffcc00'
};

const themes = { light: lightColors, dark: darkColors };

function AppInner() {
  const { mode } = useThemeMode();

  return (
    <ThemeProvider theme={themes[mode]}>
      <Routes>
        <Route path="/" element={<LoginPage />} />
        <Route path="/login" element={<LoginPage />} />
        <Route path="/invoicing" element={<InvoicingPage />} />
        <Route path="/dashboard" element={<MetaLeadsOverview />} />
        <Route path="/reporting" element={<ReportingPage />} />
        <Route path="/tools" element={<ToolsPage />} />
        <Route path="/ads" element={<AdsPage />} />


        {/* <Route path="/users" element={<LandingPage />} />
        <Route path="/showcases" element={<LandingPage />} />
        <Route path="/project/:projectid" element={<LandingPage />} />
        <Route path="/marketplace" element={<LandingPage />} />
        <Route path="/reporting" element={<LandingPage />} /> */}
      </Routes>
    </ThemeProvider>
  );
}

function App() {
  return (
    <ThemeModeProvider>
      <AppInner />
    </ThemeModeProvider>
  );
}

export default App;
